import SipRedirectNew from './sip-redirect-new';

export default SipRedirectNew;
